var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-portal", [
    _c("section", { staticClass: "about-page" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("p", {}, [
                _vm._v(
                  "O cityhub.pt é a Plataforma Centralizadora de Soluções Digitais que, através do elemento comum localização, permite ao munícipe aceder a serviços sem sair de casa e ao município garantir a prestação de serviços à população com melhor qualidade e celeridade."
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-sm-center" }, [
            _c("div", { staticClass: "col-10 col-sm-auto mx-auto mr-sm-4" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: _vm.assetsPathModule("/pic-about-1.png") },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm" }, [
              _c("p", {}, [
                _vm._v(
                  "Beneficia de um design e conjunto de estilos que é comum à plataforma e às soluções que a integram, por forma a que a navegação seja fácil, entendida por todos os intervenientes e alargada aos diversos municípios do país, numa experiência intuitiva, acessível a Todos e para Todos."
                ),
              ]),
              _vm._v(" "),
              _c("p", {}, [
                _vm._v(
                  "Escalável em função das necessidades de cada município e da complexidade das suas operações diárias, o cityhub.pt é direto, prático, operacional e funcional. Os serviços são mostrados de imediato, os nomes correspondem à funcionalidade, a iconografia demonstra a utilidade."
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row highlight" }, [
            _c("div", { staticClass: "col-12 col-sm" }, [
              _c("div", { staticClass: "title mb-4" }, [
                _vm._v("Vantagens para o Município"),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-style" }, [
                _c("li", [
                  _vm._v(
                    "Disponibilizar um único ponto de contacto ao cidadão, com um design comum aos mais diversos serviços on-line"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Disponibilizar um único ponto de contacto às unidades orgânicas, com um design comum às diversas soluções aplicacionais"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Manter o contacto com o cidadão através do seu login e perfil, estreitando a comunicação, emitindo inquéritos direcionados, auscultando"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Estabelecer uma gestão de equipas mais assertiva, com o login e perfil dos seus funcionários"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Beneficiar da utilização das mais avançadas Tecnologias de Informação Geográfica para gerir o seu território com base no espaço, na localização"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Beneficiar de uma plataforma que é extensível a outros territórios, exponenciando a experiência ao território nacional"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-sm-auto mb-0 ml-sm-4 d-flex align-items-center justify-content-center justify-content-sm-end",
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: _vm.assetsPathModule("/pic-about-2.png") },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-sm-auto order-2 order-sm-1 mr-sm-4 d-flex align-items-center justify-content-center justify-content-sm-end",
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: _vm.assetsPathModule("/pic-about-3.png") },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm order-1 order-sm-2" }, [
              _c("div", { staticClass: "title mb-4" }, [
                _vm._v("Vantagens para o Cidadão"),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "list-style" }, [
                _c("li", [
                  _vm._v(
                    "Aceder aos serviços através da sua localização, das suas propriedades, das suas pretensões"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Dispor de uma ferramenta de comunicação para enviar as suas sugestões e partilhar as preocupações ao Município"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Criar uma identidade sua através do login e perfil, passando a ter “passaporte” de munícipe, estando envolvido"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Manter-se protegido e usufruir da conveniência de evitar as deslocações e as filas nos serviços"
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }